import { BCMSRecord, useGlobalController, useRouteData } from "@bcm-dev/bcms-vite";
import { Biller } from "model";

import WidgetView, { WidgetMainContentView } from "compid/shared/views/WidgetView";
import React from "react";
import { SVGAsset } from "res";

import "./styles.css";

/**
 * @function BillerDetailsEditConfirmation
 * @returns {React.Component}
 * @description The confirmation banner for when editing a biller
 * @example
 * <BillerDetailsEditConfirmation />
 */
export default function BillerDetailsEditConfirmation() {
    // Initalize a global controller instance of initalize the controller for the biller model
    const controller = useGlobalController();
    BCMSRecord.globalControllerFor([ Biller ], controller);
    // Get the route data and clear the data so it doesn't show when a refresh occurs
    const { route } = useRouteData();
    window.history.replaceState({}, document.title);

    let isShown = false;
    let biller = {};
    let updatedBillerProps = {};
    let billerOld = {};

    if(route !== null && route.confirmation) {
        const { edited, biller: routeBiller } = route.confirmation;

        // Create an object of biller properties that have been updated.
        updatedBillerProps = Object.keys(routeBiller).reduce((acc, key) => {
            billerOld = route.confirmation.billerOld;
            if(routeBiller[key] !== billerOld[key]) {
                acc[key] = true;
            }
            return acc;
        }, {});

        biller = routeBiller;
        isShown = edited && Biller.initByID(biller.billerID) instanceof Biller;
    }

    // Default success message.
    const updatedBillerPropsObjLength = Object.keys(updatedBillerProps).length;
    let successMessage = <>Your changes to <b>{ biller.billerName } { biller.billerNumber }</b> have been saved.</>;

    // If the biller name has been updated, this code updates the success message to reflect that.
    if(updatedBillerPropsObjLength > 0) {
        if(updatedBillerPropsObjLength === 1) {
            if(updatedBillerProps.billerName) {
                successMessage = <><b>{ billerOld.billerName }</b> has been successfully changed to <b>{ biller.billerName }</b> </>;
            }
        } else {
            if(updatedBillerProps.billerName) {
                successMessage = <><b>{ billerOld.billerName }</b> has been successfully changed to <b>{ biller.billerName }</b>,
                and other changes have been successfully saved.
                 </>;
            }
        }
    }
    
    return (
        <>
            { isShown &&
                <WidgetView className="empty edited-confirmation-prompt">
                    <WidgetMainContentView>
                        <SVGAsset className="icon" id="CheckmarkIcon" />
                        <span className="sub-text">{ successMessage }</span>
                    </WidgetMainContentView>
                </WidgetView>
            }
        </>
    );
}